<template>
   <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td><span class="invisible">adsd</span></td>
                            <td class="text-right text-white font-weight-bold">LEVEL 1</td>
                            <td class="text-right text-white font-weight-bold">LEVEL 2</td>
                            <td class="text-right text-white font-weight-bold">LEVEL 3</td>
                            <td class="text-right text-white font-weight-bold">TOTAL</td>
                        </tr>
                        <tr class="med-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="4" class="text-center text-white font-weight-bold">KD ’000</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="blueColor" colspan="5">31 December 2019</td>
                        </tr>
                        <tr>
                            <td class="text-dark" colspan="5">Financial assets at fair value:</td>
                        </tr>
                        <tr>
                            <td>Investments at fair value through profit or loss</td>
                            <td class="text-right">740</td>
                            <td class="text-right">9,045</td>
                            <td class="text-right">-</td>
                            <td class="text-right">9,785</td>
                        </tr>
                        <tr>
                            <td>Investments at fair value through other <br/>comprehensive income</td>
                            <td class="text-right">1,676</td>
                            <td class="text-right">1,897</td>
                            <td class="text-right">1,752</td>
                            <td class="text-right">5,325</td>
                        </tr>
                            <tr class="dark-gray">
                            <td class="text-white font-weight-bold">Total assets</td>
                            <td class="text-right text-white font-weight-bold">2,416</td>
                            <td class="text-right text-white font-weight-bold">10,942</td>
                            <td class="text-right text-white font-weight-bold">1,752</td>
                            <td class="text-right text-white font-weight-bold">15,110</td>
                        </tr>

                        <tr>
                            <td class="blueColor" colspan="5">31 December 2020</td>
                        </tr>
                        <tr>
                            <td class="text-dark" colspan="5">Financial assets at fair value: </td>
                        </tr>
                        <tr>
                            <td>Investments at fair value through profit or loss</td>
                            <td class="text-right">736</td>
                            <td class="text-right">7,804</td>
                            <td class="text-right">-</td>
                            <td class="text-right">8,540</td>
                        </tr>
                        <tr>
                            <td>Investments at fair value through other <br/>comprehensive income</td>
                            <td class="text-right">1,240</td>
                            <td class="text-right">2,091</td>
                            <td class="text-right">3,029</td>
                            <td class="text-right">6,360</td>
                        </tr>
                            <tr class="dark-gray">
                            <td class="text-white font-weight-bold">Total assets</td>
                            <td class="text-right text-white font-weight-bold">1,976</td>
                            <td class="text-right text-white font-weight-bold">9,895</td>
                            <td class="text-right text-white font-weight-bold">3,029</td>
                            <td class="text-right text-white font-weight-bold">14,900</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Arabic -->
        
        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td><span class="invisible">adsd</span></td>
                            <td class="text-right text-white font-weight-bold">المستوى 1</td>
                            <td class="text-right text-white font-weight-bold">المستوى 2</td>
                            <td class="text-right text-white font-weight-bold">المستوى 3</td>
                            <td class="text-right text-white font-weight-bold">المجموع</td>
                        </tr>
                        <tr class="med-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="4" class="text-center text-white font-weight-bold">ألف دينار كويتي</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="blueColor" colspan="5">31 ديسمبر 2020</td>
                        </tr>
                        <tr>
                            <td class="text-dark" colspan="5">موجودات مالية بالقيمة العادلة</td>
                        </tr>
                        <tr>
                            <td>استثمارات بالقيمة العادلة من خلال بيان الربح أو الخسارة</td>
                            <td class="text-right"> 740</td>
                            <td class="text-right">9,045</td>
                            <td class="text-right">-</td>
                            <td class="text-right">9,785</td>
                        </tr>
                        <tr>
                            <td>استثمارات بالقيمة العادلة من خلال الدخل الشامل الآخر</td>
                            <td class="text-right">1,676</td>
                            <td class="text-right">1,897</td>
                            <td class="text-right">1,752</td>
                            <td class="text-right">5,325</td>
                        </tr>
                            <tr class="dark-gray">
                            <td class="text-white font-weight-bold">مجموع الموجودات</td>
                            <td class="text-right text-white font-weight-bold">2,416</td>
                            <td class="text-right text-white font-weight-bold">10,942</td>
                            <td class="text-right text-white font-weight-bold">1,752</td>
                            <td class="text-right text-white font-weight-bold">15,110</td>
                        </tr>

                        <tr>
                            <td class="blueColor" colspan="5">31 ديسمبر 2019</td>
                        </tr>
                        <tr>
                            <td class="text-dark" colspan="5">موجودات مالية بالقيمة العادلة</td>
                        </tr>
                        <tr>
                            <td>استثمارات بالقيمة العادلة من خلال بيان الربح أو الخسارة</td>
                            <td class="text-right">736</td>
                            <td class="text-right">7,804</td>
                            <td class="text-right">-</td>
                            <td class="text-right">8,540</td>
                        </tr>
                        <tr>
                            <td>استثمارات بالقيمة العادلة من خلال الدخل الشامل الآخر</td>
                            <td class="text-right">1,240</td>
                            <td class="text-right">2,091</td>
                            <td class="text-right">3,029</td>
                            <td class="text-right">6,360</td>
                        </tr>
                            <tr class="dark-gray">
                            <td class="text-white font-weight-bold">مجموع الموجودات</td>
                            <td class="text-right text-white font-weight-bold">1,976</td>
                            <td class="text-right text-white font-weight-bold">9,895</td>
                            <td class="text-right text-white font-weight-bold">3,029</td>
                            <td class="text-right text-white font-weight-bold">14,900</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
   </div>
</template>

<script>
export default {

}
</script>

<style>

</style>